.typeFilter {
  flex-basis: 35%;
  margin-bottom: 1em;
}
